import { createContext } from 'react'

import type { OfferDataResponseApiType, PartnerConfigResponseSchema } from 'app/api/api.schemas'

/**
 * Partner / offer shared UI state (theme branding, config query results).
 *
 * Lives in its own module so Vite Fast Refresh can reload `shared.tsx` without
 * replacing this context object — otherwise `SharedProvider` and
 * `useSharedContext` can briefly disagree after hot updates (e.g. playground
 * agent editing files), which surfaced as "must be used within … Provider".
 */
export type SharedContextType = {
    partnerConfig: PartnerConfigResponseSchema | undefined
    partnerConfigLoading: boolean
    partnerConfigError: Error | null
    /** True when Kizzo branding (logo, theme) should be shown — origination: offer.is_kizzo; prequal: partner config or Kizzo partner id */
    isKizzoBranded: boolean
    /** Fig Elite (super-prime) origination — nav uses Fig Elite mark */
    isSuperPrimeOffer: boolean
    /** Offer data for origination - used for KIZZO_TO_FIG logo safeguard */
    offerData?: { data?: OfferDataResponseApiType } | null
}

export const SharedContext = createContext<SharedContextType | undefined>(undefined)
